export const USER_NOT_FOUND = 404;
export const SIGN_IN_UNCOMPLETED = 400;
export const OK = 200;
